{
	"2FA Code": "Two-factor Authentication Code",
	"2FA Code is required": "Two-factor Authentication Code is required",
	"ACCEPTED": "Accepted",
	"ADOBE STOCK": "Adobe stock",
	"APPROVED": "Approved",
	"ARTICLE GENERATION": "Article Generation",
	"ARTICLE": {
		"COPYRIGHT": "Copyright",
		"SOURCE": "Source"
	},
	"Add": "Add",
	"Add to article": "Add to Article",
	"Advertiser": "Advertiser",
	"Application error occurred": "Application Error Occurred",
	"Approval time": "Approval time",
	"Approve all": "Approve all",
	"Article ID": "Article ID",
	"Article assets": "Article Assets",
	"Article summary in English": "Article summary in English",
	"Author": "Author",
	"Budget amount": "Budget Amount",
	"Budget type": "Budget Type",
	"CAMPAIGN": "Campaign",
	"CANCELLED": "Cancelled",
	"CMS": "CMS",
	"CONTENT": "Content",
	"CTA": "Call to Action",
	"Campaign name": "Campaign Name",
	"Cancel": "Cancel",
	"Categories": "Categories",
	"Category": "Category",
	"Change password": "Change Password",
	"Clear": "Clear",
	"Code must contains 6 characters": "Code must contain 6 characters",
	"Collapse": "Collapse",
	"Content type": "Content type",
	"Countries": "Countries",
	"Country": "Country",
	"Create": "Create",
	"Create article": "Create Article",
	"Create lockscreen resource": "Create Lockscreen Resource",
	"Created By": "Created By",
	"Created Time": "Created Time",
	"Created by": "Created by",
	"Created time": "Created time",
	"Creator": "Creator",
	"DRAFT": "Draft",
	"Date": "Date",
	"Description": "Description",
	"Download": "Download",
	"Duplicate Lockscreen Resources": "Duplicate Lockscreen Resources",
	"Duration days": "Duration (Days)",
	"EXPIRED": "Expired",
	"Email": "Email",
	"Email address": "Email Address",
	"Email address required": "Email Address Required",
	"Email is required": "Email is required",
	"Email with temporary password has been sent!": "Email with temporary password has been sent!",
	"End date": "End date",
	"Enter a CTA": "Enter a CTA",
	"Enter a Summary": "Enter a Summary",
	"Enter a author": "Enter an Author",
	"Enter a campaign name": "Enter a campaign name",
	"Enter a description": "Enter a Description",
	"Enter a duration days": "Enter a Duration (Days)",
	"Enter a landing page URL": "Enter a landing page URL",
	"Enter a subtitle": "Enter a subtitle",
	"Enter a title": "Enter a Title",
	"Enter a traffic percent": "Enter a traffic percent",
	"Enter a weekly frequency": "Enter a weekly frequency",
	"Enter an ID": "Enter an ID",
	"Enter your email address": "Enter your Email Address",
	"Existing images suggestions": "Existing images suggestions",
	"Expand": "Expand",
	"Export": "Export",
	"Field is required": "Field is required",
	"Field value should be 0 or more": "Field value should be 0 or more",
	"Field value should be integers": "Field value should be integers",
	"File size is too large": "File size is too large",
	"Forgot your password?": "Forgot your password?",
	"Frequency": "Frequency",
	"Fullscreen": "Fullscreen",
	"GETTY IMAGES": "Getty images",
	"INTERNATIONAL": "International",
	"IN_REVIEW": "In Review",
	"If you have an account, we'll email you instructions": "If you have an account, we'll email you instructions",
	"Image provider": "Image Provider",
	"Impressions": "Impressions",
	"Incorrect email address": "Incorrect email address",
	"International": "International",
	"Invalid dimensions": {
		" Expected resolution is 1440 x 2560": "Invalid dimensions. Expected resolution is 1440 x 2560"
	},
	"LIVE": "Live",
	"Label": "Label",
	"Landing page URL": "Landing Page URL",
	"Language": "Language",
	"List empty": "List empty",
	"Lockscreen Type": "Lockscreen Type",
	"Lockscreen resources": "Lockscreen Resources",
	"Log in": "Log in",
	"Login": "Login",
	"Login with Google": "Login with Google",
	"Logout": "Logout",
	"NO STATUS": "No Status",
	"NO TYPE": "No Type",
	"NOT AVAILABLE": "Not available",
	"Name": "Name",
	"Name, ID": "Name, ID",
	"New password": "New Password",
	"Next": "Next",
	"OEM": "OEM",
	"OEM Audit Status": "OEM Audit Status",
  "HONOR": {
    "AUDIT": {
      "PASS": "Pass",
      "DUBIOUS": "Dubious",
      "FAIL": "Fail",
      "TITLE": {
        "LABEL": "Title"
      },
      "DESCRIPTION": {
        "LABEL": "Description"
      },
      "IMAGE": {
        "LABEL": "Image"
      },
      "H5": {
        "LABEL": "H5"
      }
    },
    "AUTO_AUDIT_RESULT": {
      "LABEL": "Auto audit result"
    },
    "RESULTS": {
      "ACCEPT": "Accept",
      "DUBIOUS": "Dubious",
      "VALIDATE": "Validate",
      "REJECT": "Reject",
      "UNKNOWN": "Unknown"
    }
  },
	"PAGE": {
		"ARTICLE": {
			"ACTIONS": {
				"ACCEPT": {
					"LABEL": "Accept",
					"TOOLTIP": "Article cannot be accepted without a category"
				},
				"CROP": "Crop",
				"EDIT": "Edit",
				"PROMOTE": {
					"DISABLED": "This article is already marked as Trending News",
					"LABEL": "Promote",
					"TOOLTIP": "Click to mark this article as Trending News"
				},
				"PROMOTE_GLOBAL": {
					"LABEL": "Promote",
					"TOOLTIP": "Click to mark this article as Global Search News"
				},
				"REJECT": "Reject"
			},
			"FIELD": {
				"ID": {
					"TOOLTIP": "Article ID",
					"VALUE": "ID: {{value}}"
				}
			},
			"LIST": {
				"ACTION": {
					"CLEAR_FILTERS": "Clear filters",
					"CREATE": "Create"
				},
				"HEADER": "Articles",
				"SEARCH_TERM": {
					"LABEL": "Title, author, created by, articleURL"
				}
			},
			"SELECTED_ELEMENTS": {
				"ACTIONS": {
					"ACCEPT_ALL": "Accept all",
					"CLEAR_SELECTION": "Clear selection",
					"DUPLICATE_ALL": "Duplicate all",
					"PROMOTE_ALL": "Promote all",
					"REJECT_ALL": "Reject all",
					"SELECT_ALL": "Select all"
				},
				"LABEL": "Selected elements: {{value}}"
			},
			"STATUS": {
				"DONE": "Done",
				"FINISHING": "Finishing",
				"NO_STATUS": "No status",
				"PROCESSING": "Processing"
			}
		},
		"ARTICLE_SUGGESTIONS": {
			"DIALOG": {
				"HEADER": "Browse by suggestion set"
			},
			"LIST_ITEM": {
				"ACTION": {
					"SHOW_MORE": "See more"
				},
				"HEADER": "Suggestion {{value}}"
			},
			"SEARCH": {
				"HEADER": "Existing images suggestions"
			}
		},
		"AUDIENCE": {
			"CREATE": "Click the \"Add\" button to create a new audience."
		},
		"CAMPAIGN": {
			"ACTIONS": {
				"DETAILS": "Details"
			},
			"CREATE": {
				"ALERT": {
					"ERROR": "There was an error creating the campaign. Please try again.",
					"SUCCESS": "Campaign created successfully!"
				},
				"FORM": {
					"ACTIONS": {
						"CANCEL": "Cancel",
						"SUBMIT": "Submit"
					}
				},
				"HEADER": "Create campaign",
				"LABEL": "Add new campaign"
			},
			"DATEPICKER": {
				"LABEL": "Select date"
			},
			"DETAILS": {
				"FIELD": {
					"AUDIENCES": "Audiences",
					"CAMPAIGN_ID": "Campaign ID",
					"END_DATE": "End date",
					"START_DATE": "Start date",
					"TRAFFIC_PERCENT": "Traffic percent"
				},
				"HEADER": "Campaign details"
			},
			"HEADER": "Campaigns",
			"SEARCH_TERM": {
				"LABEL": "Search"
			}
		},
		"COMPONENTS": {
			"COPY_TO_CLIPBOARD": {
				"ALERT": "Copied to clipboard!",
				"LABEL": "Copy to clipboard"
			},
			"DASHBOARD": {
				"EMPTY": {
					"HEADER": "No data",
					"SUBHEADER": "No results for selected criteria"
				}
			},
			"DATEPICKER": {
				"LABEL": "Select date",
				"SIDE_PANEL": {
					"LABEL": "Filter dates by"
				}
			},
			"DIALOG": {
				"BUTTONS": {
					"BACK": "Back"
				}
			},
			"IMAGE_UPLOAD": {
				"IN_PROGRESS": "Uploading..."
			},
			"LIST": {
				"EMPTY": {
					"HEADER": "List empty",
					"SUBHEADER": "No results for selected criteria"
				}
			},
			"SELECT_FILE": {
				"HEADER": "Drag and drop a file to upload",
				"SUBHEADER": "Or select a file from your computer"
			}
		},
		"CONFIRMATION_DIALOG": {
			"CANCEL": "Cancel",
			"OK": "OK"
		},
		"CREATOR": {
			"DATEPICKER": {
				"LABEL": "Enter a review date"
			},
			"DETAILS": {
				"HEADER": "Creator details"
			},
			"HEADER": "Creators",
			"LIST": {
				"ACTIONS": {
					"OPEN_DETAILS": "Open details",
					"OPEN_REVIEW": "Start review"
				},
				"FIELDS": {
					"CATEGORY": "Category",
					"CUTOFF": "Cutoff date (optional)",
					"DRAFT_VIDEOS": "Draft videos",
					"INTERNATIONAL": "International",
					"PLATFORM": "Platform",
					"REVIEWED_BY": "Reviewed by",
					"REVIEW_DATE": "Review date",
					"STATUS": "Status",
					"TOTAL_VIDEOS": "Total videos"
				}
			},
			"REVIEW": {
				"FOOTER": {
					"COUNTER": "Reviewing video {{value}} of {{total}}"
				},
				"HEADER": "Creator review process"
			},
			"REVIEW_STATUS": {
				"ACCEPTED": "Accepted",
				"DRAFT": "Draft",
				"EMPTY": "NO DATA",
				"REJECTED": "Rejected"
			},
			"SEARCH_TERM": {
				"LABEL": "Created by, Video name"
			}
		},
		"DASHBOARD": {
			"DATEPICKER": {
				"LABEL": "Select date"
			},
			"FILTER": {
				"OPEN_TYPE": {
					"LABEL": "Open type"
				},
				"POSITION": {
					"LABEL": "Position"
				}
			},
			"FILTERS": {
				"MIN_CTR": "Min CTR",
				"MIN_IMPRESSIONS": "Min Impressions"
			},
			"OVERVIEW": {
				"HEADER": "Dashboard",
				"LIST": {
					"FIELD": {
						"CATEGORY": "Category",
						"CLICKS": "Clicks",
						"COUNTRY": "Country",
						"CTR": "CTR",
						"DATE": "Date",
						"DURATION_ARTICLE": "Duration (Article)",
						"DURATION_LS": "Duration (LS)",
						"ID": "ID",
						"IMPRESSIONS": "Impressions",
						"PUBLISHER": "Publisher"
					}
				}
			}
		},
		"DETAILS": {
			"ERROR": {
				"HEADER": "An unexpected error occurred.",
				"SUBHEADER": "Try again later!"
			}
		},
		"ERROR": {
			"ACTION": "Back to dashboard",
			"HEADER": "The page you are looking for is not available"
		},
		"FIELD": {
			"ADVERTISER": "Advertiser",
			"ARTICLE_DOMAIN": "Article domain",
			"CATEGORY": "Category",
			"CLUSTER": "Cluster",
			"CONTENT_TYPE": "Content Type",
			"HAS_LOCKSCREEN_RESOURCE": "Has lockscreen resources",
			"HAS_TRENDING_NEWS": "Has trending news",
			"HAS_VIDEO": "Has video",
			"LOCKSCREEN_TYPE": "Lockscreen Type",
			"MEDIA_GROUP": "Media Group",
			"ORIENTATION": "Orientation",
			"PUBLICATION": "Publisher",
			"PUBLISHER_DOMAIN": "Publisher domain",
			"TAGS": "Tags",
			"VIDEO_CREATOR": "Video creator",
			"VIDEO_PROVIDER": "Video provider",
      "VISIBLE": "Visible",
      "SENSITIVE_KEYWORDS": "Sensitive keywords",
      "IAB_CATEGORY": "IAB category"
		},
		"FILTER": {
			"DASHBOARD": {
				"OPEN_TYPE": {
					"OPTIONS": {
						"CTA": "CTA",
						"SLIDEUP": "Slide Up"
					}
				},
				"POSITION": {
					"OPTIONS": {
						"ACTIVE": "Active",
						"PASSIVE": "Passive"
					}
				}
			},
			"GENERATION_JOB": {
				"STATUS": {
					"LABEL": "Status"
				}
			},
			"HAS_LOCKSCREEN_RESOURCE": {
				"OPTIONS": {
					"NO": "Not on lockscreen",
					"YES": "On lockscreen"
				}
			},
			"HAS_TRENDING_NEWS": {
				"OPTIONS": {
					"NO": "No",
					"YES": "Yes"
				}
			},
			"HAS_VIDEO": {
				"OPTIONS": {
					"NO": "No",
					"YES": "Yes"
				}
			},
			"ORIENTATION": {
				"OPTIONS": {
					"HORIZONTAL": "Horizontal",
					"SQUARE": "Square",
					"VERTICAL": "Vertical"
				}
			},
			"VISIBLE": {
				"OPTIONS": {
					"NO": "No",
					"YES": "Yes"
				}
			},
			"WORD_COUNT": {
				"FROM": "From",
				"LABEL": "Word count",
				"SUBHEADER": "Word count",
				"TO": "Words count"
			}
		},
		"FILTERS": {
      "TITLE": "Filters",
			"GLOBAL": "Global",
			"NONE": "None",
			"OEM": {
				"LABEL": "OEM"
			},
			"OPTIONS": {
				"ALL": "All"
			}
		},
		"FORM": {
			"ERRORS": {
				"PATTERN": "Incorrect format",
				"REQUIRED": "Field is required"
			}
		},
		"GENERATION_JOB": {
			"ACTIONS": {
				"CANCEL": "Cancel",
				"DETAILS": "Details",
				"VIEW_ARTICLES": "View articles"
			},
			"CREATE": {
				"ALERT": {
					"ERROR": "File upload failed. Details: {{value}}",
					"SUCCESS": "Generation job created"
				},
				"FORM": {
					"ACTIONS": {
						"CANCEL": "Cancel",
						"SUBMIT": "Submit",
						"VERIFY": "Verify"
					},
					"FIELDS": {
						"FILE": {
							"LABEL": "Upload your file"
						},
						"PROMPT_TEMPLATE": {
							"LABEL": "Enter a prompt template",
							"PLACEHOLDER": "Prompt template"
						}
					}
				},
				"HEADER": "Create generation job",
				"LABEL": "Create",
				"PROMPTS": "Prompts"
			},
			"DATEPICKER": {
				"LABEL": "Enter a created date"
			},
			"DETAILS": {
				"ACTIONS": {
					"CANCEL": "Cancel"
				},
				"FIELD": {
					"CREATED_BY": "Created by",
					"CREATED_TIME": "Created time",
					"JOB_ID": "Job ID",
					"JOB_STATUS": "Status",
					"JOB_TYPE": "Type",
					"PROMPT_TEMPLATE": "Prompt template",
					"STATUS": "Status",
					"TASKS_FINISHED": "Tasks finished",
					"UPDATED_TIME": "Updated time"
				},
				"HEADER": "Generation job details",
				"WARNING": {
					"TASKS_NOT_FINISHED": "Some tasks are not finished"
				}
			},
			"HEADER": "Generation jobs",
			"SEARCH_TERM": {
				"LABEL": "Created by"
			},
			"STATUS": {
				"CANCELLED": "Cancelled",
				"CREATED": "Created",
				"DONE": "Done",
				"FAILED": "Failed",
				"INITIAL": "Initial",
				"IN_PROGRESS": "In progress"
			},
			"UPLOAD": {
				"HINT": "Allowed file extension: `.tsv`"
			},
			"VERIFY": {
				"ALERT": {
					"ERROR": "Verification failed. Details: {{value}}",
					"SUCCESS": "Verification succeeded"
				}
			}
		},
		"GLOBAL_SEARCH_NEWS": {
			"ACTIONS": {
				"DETAILS": "Details",
				"EXPIRE": "Expire",
				"PUBLISH": "Publish",
				"REMOVE": "Remove",
				"UNPUBLISH": "Unpublish"
			},
			"DATEPICKER": {
				"LABEL": "Select date"
			},
			"DETAILS": {
				"FIELD": {
					"ID": "ID",
					"REJECTION_REASON": "Rejected reason",
					"STATUS": "Status"
				},
				"HEADER": "Global search news details"
			},
			"HEADER": "Global search news",
			"SEARCH_TERM": {
				"LABEL": "Search by title, description, content ID"
			},
			"STATUS": {
				"ALL": "All",
				"APPROVED": "Approved",
				"CANCELLED": "Cancelled",
				"DRAFT": "Draft",
				"EXPIRED": "Expired",
				"IN_REVIEW": "In Review",
				"LIVE": "Live",
				"PENDING": "Pending",
				"REJECTED": "Rejected"
			},
			"TYPE": {
				"BREAKING": "Breaking",
				"ROUTINE": "Routine"
			},
			"UPLOAD": {
				"HINT": "Allowed file extension: `.zip`"
			}
		},
		"IMAGE_ACTIONS": {
			"ADD": {
				"LABEL": "Use as Lockscreen image"
			},
			"DOWNLOAD": {
				"LABEL": "Download"
			},
			"FULLSCREEN": {
				"LABEL": "Fullscreen"
			}
		},
		"LIST": {
			"ERROR": {
				"HEADER": "An unexpected error occurred.",
				"SUBHEADER": "Try again later!"
			},
			"TOTAL": "Total: {{value}}"
		},
		"LOCKSCREEN_IMPORT": {
			"CREATE": {
				"FORM": {
					"FIELDS": {
						"GOOGLE_SHEET_URL": {
							"LABEL": "Enter a GSheet URL",
							"PLACEHOLDER": "GSheet URL"
						}
					}
				}
			},
			"STATUS": {
				"DONE": "Done",
				"ERROR": "Error",
				"FINISHING": "Finishing",
				"NEW": "New",
				"PROCESSING": "Processing",
				"TO_REFRESH": "To refresh"
			}
		},
		"LOCKSCREEN_RESOURCE": {
			"ACTIONS": {
				"DUPLICATE": "Duplicate",
				"EDIT": "Edit",
				"PUBLISH": "Publish",
				"REMOVE": "Remove",
				"WITHDRAW": "Withdraw"
			},
      "FIELDS": {
        "PLANNED_PUBLISHING": "Planned publishing"
      },
      "FILTERS": {
        "PLANNED_PUBLISHING_DATE": "Planned publishing date"
      },
			"IMAGE_RECOMMENDATIONS": {
				"DISCOVER": "Discover more images"
			},
      "SCHEDULE": {
        "TITLE": "Schedule publishing",
		  "HINT": "Select the date when the selected items will be published.",
        "DATE_LABEL": "Publishing date",
        "SAVE": "Schedule",
        "ERRORS": {
          "DATE_REQUIRED": "Date is required.",
					"MUST_BE_FUTURE": "The scheduled date must be in the future."
        }
      },
			"SELECTED_ELEMENTS": {
				"ACTIONS": {
					"CLEAR_SELECTION": "Clear selection",
					"PUBLISH_ALL": "Publish all",
          "SCHEDULE": "Schedule",
          "TRANSLATE": "Translate",
					"SELECT_ALL": "Select all"
				},
        "LABEL": "Selected elements: {{value}}",
        "SELECTED_LABEL": "selected"
      },
      "TRANSLATE": {
        "TITLE": "Translate to",
        "LANGUAGE_LABEL": "Language",
        "SUBMIT": "Submit",
        "CANCEL": "Cancel",
        "CLOSE": "Close",
        "RESULTS_TITLE": "Results",
        "REQUESTS_SENT": "{{value}} requests were sent.",
        "NEW_RESOURCES": "{{value}} new Lockscreen resources will be created.",
        "NOT_PROCESSED": "{{value}} requests were not processed and hence not created new lock screen resources.",
        "NON_SUPPORTED_OEM": "{{value}} requests were in non-supported OEM.",
        "ALREADY_TRANSLATED": "{{value}} requests were already done in the past. Here are a few examples:",
        "EXAMPLE_PREFIX": "LS resource \"{{title}}\" translate from",
        "TO": "to"
			}
		},
		"PAGINATION": {
			"ACTIONS": {
				"GO": "Go",
				"PAGE": "Page"
			}
		},
		"PUBLISHERS": {
			"ACTIONS": {
				"DETAILS": "Details"
			},
			"DETAILS": {
				"FIELD": {
					"ID": "ID"
				},
				"HEADER": "Publisher details"
			},
			"HEADER": "Publishers",
			"SEARCH_TERM": {
				"LABEL": "Search term"
			},
			"UPLOAD": {
				"HINT": "Allowed file extension: `.svg` , `,img`, `.png"
			}
		},
		"QUIZ": {
			"ACTIONS": {
				"DETAILS": {
					"LABEL": "Open details"
				}
			},
			"DATEPICKER": {
				"LABEL": "Date range"
			},
			"DETAILS": {
				"FIELD": {
					"CATEGORY": "",
					"COMPRESSED_URL": "",
					"COSMOSE_URL": "",
					"CREATED_BY": "",
					"CREATOR": "",
					"KEYWORDS": "",
					"ORIENTATION": "",
					"ORIGINAL_URL": "",
					"PROVIDER_LANGUAGE": "",
					"PROVIDER_NAME": "",
					"QUIZ_ID": "",
					"REVIEW_STATUS": "",
					"STATUS": "",
					"TITLE": ""
				}
			},
			"HEADER": "Quiz list",
			"SEARCH_TERM": {
				"LABEL": "Search term"
			},
			"STATUS": {
				"DONE": "",
				"ERROR": "",
				"FINISHING": "",
				"LABEL": "",
				"NEW": "",
				"PROCESSING": "",
				"TO_REFRESH": ""
			}
		},
		"RANKED_ARTICLE": {
			"LIST": {
				"HEADER": "Ranked articles"
			}
		},
		"SIDENAV": {
			"ARTICLES": "Articles",
			"ARTICLES_LEGACY": "Articles (Legacy)",
			"CAMPAIGNS": "Campaigns",
			"CREATORS": "Creators",
			"DASHBOARD": "Dashboard",
			"GENERATION_JOBS": "Generation jobs",
			"GLOBAL_SEARCH_NEWS": "Global search",
      "HONOR_REVENUE": "Honor revenue",
			"LOCKSCREEN_RESOURCES": "Lockscreen resources",
			"PUBLISHERS": "Publishers",
			"QUIZ_LIST": "Quiz list",
			"RANKED_ARTICLES": "Ranked articles",
			"TOP_VIDEOS": "Top Videos",
			"TRENDING_NEWS": "Trending news",
			"VIDEOS": "Videos",
			"VIDEO_CAMPAIGNS": "Video Campaigns",
			"VIDEO_IMPORTS": "Video imports"
		},
		"TOP_VIDEO": {
			"ACTIONS": {
				"DUPLICATE": "Create LS resource"
			},
			"DATEPICKER": {
				"LABEL": "Enter a created date"
			},
			"DETAILS": {
				"FIELD": {
					"AVG_EXPOSURE": "Avg. Watch Time",
					"COUNTRY": "Country",
					"CREATED_TIME": "Created time",
					"NUM_EXPOSURES": "Views",
					"ORIGINAL_URL": "Original URL",
					"PUBLISHER": "Publisher",
					"RESOURCE_ID": "Lockscreen ID",
					"TITLE": "Title",
					"VIDEO_ID": "Video ID"
				}
			},
			"HEADER": "Top Videos",
			"SEARCH_TERM": {
				"LABEL": "Created by, Video name"
			}
		},
		"TRENDING_NEWS": {
			"ACTIONS": {
				"DETAILS": "Details",
				"PUBLISH": "Publish",
				"REMOVE": "Remove",
				"UNPUBLISH": "Unpublish"
			},
			"DATEPICKER": {
				"LABEL": "Select date"
			},
			"DETAILS": {
				"FIELD": {
					"ID": "ID",
					"STATUS": "Status",
					"TYPE": "Type"
				},
				"HEADER": "Trending News details",
				"PREVIEW_LABEL": "Preview"
			},
			"HEADER": "Trending news",
			"SEARCH_TERM": {
				"LABEL": "Search term"
			},
			"STATUS": {
				"ALL": "All",
				"DELIVERED": "Delivered",
				"DRAFT": "Draft",
				"PARTIALLY_DELIVERED": "Partially delivered",
				"PENDING": "Pending"
			},
			"TYPE": {
				"BREAKING": "Breaking",
				"ROUTINE": "Routine"
			},
			"UPLOAD": {
				"HINT": "Allowed file extension: `.zip`"
			}
		},
		"VIDEO": {
			"ACTIONS": {
				"ACCEPT": {
					"LABEL": "Accept"
				},
				"DETAILS": {
					"LABEL": "Details"
				},
				"DRAFT": {
					"LABEL": "Draft"
				},
				"REJECT": {
					"LABEL": "Reject"
				},
				"WITHDRAW": {
					"LABEL": "Withdraw"
				}
			},
			"CREATE": {
				"ALERT": {
					"ERROR": "File upload failed. Details: {{value}}",
					"SUCCESS": "Video created"
				},
				"FIELD": {
					"CATEGORY": "Category",
					"COUNTRY": "Country",
					"VIDEO_PROVIDER": "Video provider"
				},
				"FORM": {
					"ACTIONS": {
						"CANCEL": "Cancel",
						"SUBMIT": "Submit"
					},
					"FIELDS": {
						"DESCRIPTION": {
							"LABEL": "Description",
							"PLACEHOLDER": "Provide a description"
						},
						"FILE": {
							"LABEL": "Upload your file"
						},
						"TITLE": {
							"LABEL": "Title",
							"PLACEHOLDER": "Provide a title"
						}
					}
				},
				"HEADER": "Create a video",
				"LABEL": "Create"
			},
			"DATEPICKER": {
				"LABEL": "Enter a created date"
			},
			"DETAILS": {
				"FIELD": {
					"CATEGORY": "Category",
					"COMPRESSED_URL": "Compressed URL",
					"COSMOSE_URL": "Cosmose URL",
					"COUNTRY": "Country",
					"CREATED_BY": "Created by",
					"CREATOR": "Creator",
					"INTERNATIONAL": "International",
					"KEYWORDS": "Keywords",
					"ORIENTATION": "Orientation",
					"ORIGINAL_URL": "Original URL",
					"PROVIDER_LANGUAGE": "Provider language",
					"PROVIDER_NAME": "Provider",
					"REVIEW_STATUS": "Review status",
					"STATUS": "Status",
					"TITLE": "Title",
					"VIDEO_ID": "Video ID"
				},
				"HEADER": "Video details"
			},
			"HEADER": "Videos",
			"REVIEW_STATUS": {
				"ACCEPTED": "Accepted",
				"DRAFT": "Draft",
				"REJECTED": "Rejected"
			},
			"SEARCH_TERM": {
				"LABEL": "Created by, Video name"
			},
			"STATUS": {
				"DONE": "Done",
				"ERROR": "Error",
				"FINISHING": "Finishing",
				"LABEL": "Status",
				"NEW": "New",
				"PROCESSING": "Processing",
				"TO_REFRESH": "To refresh"
			},
			"UPLOAD": {
				"HINT": "Allowed file extension: `.mp4`"
			}
		},
		"VIDEO_CAMPAIGN": {
			"ACTIONS": {
				"DETAILS": "Details"
			},
			"CREATE": {
				"HEADER": "Create video campaign"
			},
			"DETAILS": {
				"FIELD": {
					"CAMPAIGN_NAME": "Campaign Name",
					"END_DATE": "End Date",
					"START_DATE": "Start Date",
					"WEIGHT": "Weight"
				},
				"HEADER": "Video Campaign Details"
			},
			"HEADER": "Video Campaigns"
		},
		"VIDEO_IMPORT": {
			"ACTIONS": {
				"DETAILS": "Details",
				"REMOVE": "Remove"
			},
			"CREATE": {
				"ALERT": {
					"ERROR": "An error occurred while creating the import. Details: {{value}}",
					"SUCCESS": "Video import was created successfully."
				},
				"FORM": {
					"ACTIONS": {
						"CANCEL": "Cancel",
						"SUBMIT": "Submit"
					}
				},
				"HEADER": "Create Video Import",
				"LABEL": "New Import"
			},
			"DATEPICKER": {
				"LABEL": "Select Date"
			},
			"DETAILS": {
				"FIELD": {
					"COUNTRIES": "Countries",
					"CREATED_BY": "Created By",
					"CREATED_TIME": "Created Time",
					"ID": "ID",
					"IMPORT_STATUS": "Status",
					"LANGUAGE": "Language",
					"STATUS": "Status",
					"TASKS_FINISHED": "Tasks Finished",
					"UPDATED_TIME": "Last Updated",
					"URL": "URL"
				},
				"HEADER": "Import Details"
			},
			"HEADER": "Video Import",
			"SEARCH_TERM": {
				"LABEL": "Search Term"
			}
    },
    "HONOR_REVENUE": {
      "ACTIONS": {
        "DETAILS": "Details"
      },
      "CREATE": {
        "FORM": {
          "ACTIONS": {
            "CANCEL": "Cancel",
            "SUBMIT": "Submit"
          },
          "REQUIRED": "Field is required",
          "SHEET_URL": "Google sheet URL"
        },
        "HEADER": "Honor revenue import",
        "LABEL": "New import"
      },
      "DETAILS": {
        "FIELD": {
          "COUNTRIES": "Countries",
          "CREATED_BY": "Created by",
          "CREATED_TIME": "Created time",
          "FAILED_RECORDS": "Failed records",
          "ID": "ID",
          "RESULT_CODE": "Result code",
          "RESULT_INFO": "Result",
          "ROW_COUNT": "Rows",
          "UPLOAD_STATUS": "Upload status",
          "RESPONSE_ID": "Response ID"
        },
        "HEADER": "Honor revenue details",
        "UPLOAD_FILE": "Upload file",
        "UPLOAD_TO_HONOR": "Upload to Honor",
        "ROW_FAILED": "Failed",
        "ROW_OK": "OK",
        "TABLE": {
          "AD_POS_FLAG": "Ad pos",
          "AD_REVENUE": "Ad revenue",
          "AD_TURNOVER": "Ad turnover",
          "CLICK_PV": "Click PV",
          "COUNTRY": "Country",
          "EXPOSURE_PV": "Exposure PV",
          "RECORD_ID": "Record ID",
          "RECORD_TIME": "Record date",
          "REQ_PV": "Req PV",
          "RETURN_PV": "Return PV",
          "ROW_STATUS": "Row status"
        },
        "UPLOAD_RESPONSE": "Upload response",
        "VALIDATION_ERRORS": "Validation errors"
      },
      "HEADER": "Honor revenue"
		}
	},
	"PENDING": "Pending",
	"Password": "Password",
	"Password doesn't match": "Password doesn't match",
	"Password has been changed!": "Password has been changed!",
	"Password is required": "Password is required",
	"Password must contain at least one numeric character": "Password must contain at least one numeric character",
	"Password required": "Password required",
	"Passwords must be at least 8 characters in length": "Passwords must be at least 8 characters in length",
	"Previous": "Previous",
	"Promote article to Global Search News": "Promote article to Global Search News",
	"Promote article to Trending News": "Promote article to Trending News",
	"Promote articles to Global Search": "Promote articles to Global Search",
	"Promote articles to Trending News": "Promote articles to Trending News",
	"Provided temporary password is incorrect!": "Provided temporary password is incorrect!",
	"Publication time": "Publication Time",
	"Publish time": "Publish time",
	"REJECTED": "Rejected",
	"Redirect URL": "Redirect URL",
	"Refresh": "Refresh",
	"Reject all": "Reject all",
	"Repeat password": "Repeat Password",
	"Report Emails": "Report Emails",
	"Reset password": "Reset Password",
	"Resource type": "Resource type",
	"Return": "Return",
	"Save": "Save",
	"Select image": "Select image",
	"Select main image": "Select main image",
	"Set as current": "Set as Current",
	"Size": "Size",
	"Start date": "Start date",
	"Status": "Status",
	"Subtitle": "Subtitle",
	"Summary": "Summary",
	"Tags": "Tags",
	"Temporary password": "Temporary Password",
	"Title": "Title",
	"Traffic percent": "Traffic percent",
	"Type": "Type",
	"Value has been updated": "Value has been updated",
	"Variant has been updated": "Variant has been updated",
	"Video URL": "Video URL",
	"Vivo Category": "Vivo category",
	"Vivo Image Category": "Vivo Image Category",
	"Vivo Image Subcategory": "Vivo Image Subcategory",
	"Vivo Subcategory": "Vivo Subcategory",
	"Weekly frequency": "Weekly frequency",
	"Weight": "Weight"
}
